import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cfs-website',
  templateUrl: './website.component.html',
  styleUrls: ['./website.component.scss']
})
export class WebsiteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
